import React from "react";

import { AW23 } from "../../../../js/database/database-aw23-eshop.js";

import ProductsContainer from "../../../../components/containers/ProductsContainer.js";
import { SwiperSlide } from "swiper/react";

const BaroqueShirtWhite = () => {
  return (
    <ProductsContainer
      pageTitle={AW23.tops.BaroqueShirtWhite.itemName}
      name={AW23.tops.BaroqueShirtWhite.itemName}
      price={AW23.tops.BaroqueShirtWhite.itemPrice}
      fabric={AW23.tops.BaroqueShirtWhite.itemFabric}
      src={AW23.tops.BaroqueShirtWhite.sizeChart}
      divId={AW23.tops.BaroqueShirtWhite.shopifyDivId}
      mainId={AW23.tops.BaroqueShirtWhite.shopifyId}
      buttonShouldHide={true}
    >
      {React.Children.toArray(
        AW23.tops.BaroqueShirtWhite.pictures.map(({ srcJpeg }) => (
          <SwiperSlide>
            <img
              src={srcJpeg}
              alt={AW23.tops.BaroqueShirtWhite.itemName}
              width={AW23.imgWidth}
              height={AW23.imgHeight}
              loading={AW23.loading}
            />
          </SwiperSlide>
        ))
      )}
    </ProductsContainer>
  );
};

export default BaroqueShirtWhite;
